/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/prefer-relative-imports */
/* eslint-disable no-prototype-builtins */
/* eslint-disable react/jsx-no-literals */

// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a
'use es6';

import { PureComponent } from 'react';
import { List } from 'immutable';
import count from 'transmute/count';
import filter from 'transmute/filter';
import PropTypes from 'prop-types';
import Raven from 'raven-js';
import { reportError } from 'conversations-error-reporting/error-reporting/reportError';
import { LogLevel } from 'conversations-error-reporting/error-reporting/constants/LogLevel';
import { isLoading, isFailed } from 'conversations-async-data/async-data/operators/statusComparators';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import * as GenericChannelIds from 'conversations-thread-data/generic-channels/public/constants';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import AgentThreadHistory from 'conversations-thread-view/thread-history/components/AgentThreadHistory';
import { isCommonMessageFormat } from 'conversations-message-history/common-message-format/operators/cmfComparators';
import MessageHistoryContext from 'conversations-inbox-message-history/MessageHistoryContext';
import ThreadHistoryWrapper from './ThreadHistoryWrapper';
import ThreadViewMessagePlaceholder from '../../thread-view/components/ThreadViewMessagePlaceholder';
import ThreadHistoryError from '../../email/components/ThreadHistoryError';
import { hasMessages } from 'conversations-message-history/thread-history/operators/hasMessages';
import { NavMarker } from 'react-rhumb';
import { THREAD_LIST_SWITCHING_MARKER, THREAD_SWITCHING_MARKER, CRITICAL_PATH_THREAD_HISTORY, SECONDARY_PATH_THREAD_HISTORY } from '../../performance-metrics/constants/performanceConstants';
import { getAdditionalPositionDescriptors } from '../operators/getAdditionalPositionDescriptors';
import { Metrics } from '../../common/Metrics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const propTypes = {
  allowContactPromotions: PropTypes.bool,
  AsyncUIAvatar: PropTypes.func.isRequired,
  asyncThreadHistory: RecordPropType('AsyncData'),
  canRestoreMessagesForThread: PropTypes.bool.isRequired,
  currentUserId: PropTypes.number.isRequired,
  fetchAgentHistory: PropTypes.func.isRequired,
  historyConfig: PropTypes.object.isRequired,
  incomingThreadId: PropTypes.string,
  messagesList: PropTypes.instanceOf(List),
  portalId: PropTypes.number.isRequired,
  threadHistoryRequestFailed: PropTypes.bool.isRequired,
  threadId: PropTypes.string.isRequired,
  genericChannelId: PropTypes.oneOf(Object.values(GenericChannelIds)),
  vid: PropTypes.number,
  slots: PropTypes.object
};
export const createCaptureOnceForKey = () => {
  const captured = {};
  return (threadId, trackFn) => {
    if (!captured.hasOwnProperty(threadId)) {
      captured[threadId] = true;
      trackFn();
    }
  };
};
export const checksumTimeoutLength = 5000;
class UnifiedThreadHistory extends PureComponent {
  constructor(props) {
    super(props);
    this.threadPerformanceMeasureOnceForThreadId = createCaptureOnceForKey();
  }
  componentDidMount() {
    try {
      performance.measure(CRITICAL_PATH_THREAD_HISTORY);
      const entries = performance.getEntriesByName(CRITICAL_PATH_THREAD_HISTORY);
      if (entries && entries.length > 0) {
        const duration = entries[0].duration;
        Raven.setExtraContext({
          [`${this.props.incomingThreadId ? CRITICAL_PATH_THREAD_HISTORY : SECONDARY_PATH_THREAD_HISTORY}`]: duration
        });
      }
    } catch (error) {
      reportError({
        error,
        extra: {
          threadId: this.props.incomingThreadId,
          message: 'error recording performance metrics thread history critical path '
        }
      });
    }
  }
  componentDidUpdate(prevProps) {
    const previousMessagesList = prevProps.messagesList;
    const currentMessagesList = this.props.messagesList;
    this.runPerformanceTimer();
    const shouldSkipDebug = this.props.genericChannelId !== GenericChannelIds.LIVE_CHAT_GENERIC_CHANNEL_ID || !previousMessagesList || !currentMessagesList;
    if (shouldSkipDebug) {
      return;
    }
    const previousCmfCount = count(filter(isCommonMessageFormat, previousMessagesList));
    const currentCmfCount = count(filter(isCommonMessageFormat, currentMessagesList));
    if (currentCmfCount > previousCmfCount) {
      const domNodeCount = document.querySelectorAll('div[data-debug-common-message-mismatch]').length;
      if (currentCmfCount !== domNodeCount) {
        reportError({
          error: new Error('Thread History <> DOM mismatch'),
          extra: {
            currentCmfCount,
            domNodeCount
          },
          level: LogLevel.info
        });
      }
    }
  }
  componentWillUnmount() {
    clearTimeout(this.checksumTimeout);
  }
  runPerformanceTimer() {
    const {
      asyncThreadHistory,
      threadId,
      vid,
      threadHistoryRequestFailed
    } = this.props;
    if (!isLoading(asyncThreadHistory) && hasMessages(getData(asyncThreadHistory)) && vid && !threadHistoryRequestFailed) {
      this.threadPerformanceMeasureOnceForThreadId(threadId, () => {
        try {
          const startEntries = performance.getEntriesByName(`${THREAD_SWITCHING_MARKER}-start-${threadId}`);
          if (startEntries && startEntries.length > 0) {
            performance.mark(`conversations-thread-list-row-stop-${threadId}`);
            performance.measure(`${THREAD_SWITCHING_MARKER}-switch-${threadId}`, `${THREAD_SWITCHING_MARKER}-start-${threadId}`, `${THREAD_SWITCHING_MARKER}-stop-${threadId}`);
            const duration = performance.getEntriesByName(`${THREAD_SWITCHING_MARKER}-switch-${threadId}`)[0].duration;
            Raven.setExtraContext({
              [`${THREAD_SWITCHING_MARKER}-switch`]: duration
            });
            Metrics.timer('thread-load-after-thread-switch').update(Math.round(duration));
          } else {
            const navigationEntry = performance.getEntriesByType('navigation')[0];
            const pageReceivedMarker = navigationEntry && navigationEntry.responseEnd;
            const threadLoadMarker = 'THREAD_LOAD_MARKER';
            performance.mark(threadLoadMarker);
            const duration = performance.now() - pageReceivedMarker;
            performance.clearMarks(threadLoadMarker);
            Metrics.timer('thread-load-after-page-load').update(Math.round(duration));
          }

          //Capture data regarding how long it takes for message history to load
          //when the user switches thread lists. Limit to once per new thread ID
          //so that we aren't measuring the duration when a thread in the
          //destination thread list is already cached, which would artificially
          //"improve" our metrics.
          const threadListSwitchEntries = performance.getEntriesByName(`${THREAD_LIST_SWITCHING_MARKER}-start`);
          if (threadListSwitchEntries && threadListSwitchEntries.length) {
            performance.mark(`${THREAD_LIST_SWITCHING_MARKER}-stop`);
            performance.measure(`${THREAD_LIST_SWITCHING_MARKER}-switch`, `${THREAD_LIST_SWITCHING_MARKER}-start`, `${THREAD_LIST_SWITCHING_MARKER}-stop`);
            const duration = performance.getEntriesByName(`${THREAD_LIST_SWITCHING_MARKER}-switch`)[0].duration;
            Raven.setExtraContext({
              [`${THREAD_LIST_SWITCHING_MARKER}-switch`]: duration
            });
          }
        } catch (error) {
          reportError({
            error,
            extra: {
              threadId,
              message: 'error recording performance metrics for thread switching '
            }
          });
        }
      });
    }
  }
  renderThreadHistory() {
    const {
      allowContactPromotions,
      asyncThreadHistory,
      canRestoreMessagesForThread,
      currentUserId,
      fetchAgentHistory,
      historyConfig,
      messagesList,
      portalId,
      threadId,
      vid,
      slots
    } = this.props;
    const props = {
      allowContactPromotions,
      canRestoreMessagesForThread,
      currentUserId,
      fetchHistory: fetchAgentHistory,
      historyConfig,
      messages: messagesList,
      portalId,
      threadHistory: getData(asyncThreadHistory),
      threadId,
      vid,
      slots,
      getAdditionalPositionDescriptors
    };
    return /*#__PURE__*/_jsx(AgentThreadHistory, Object.assign({}, props));
  }
  renderThreadHistoryStatusWrapper() {
    const {
      AsyncUIAvatar,
      asyncThreadHistory,
      vid
    } = this.props;
    const threadHistory = getData(asyncThreadHistory);
    if (isLoading(asyncThreadHistory) && !hasMessages(threadHistory) || !vid) {
      return /*#__PURE__*/_jsx(ThreadViewMessagePlaceholder, {});
    }
    if (isFailed(asyncThreadHistory) && !hasMessages(threadHistory)) {
      return /*#__PURE__*/_jsxs(NavMarker, {
        name: "THREAD_LIST_ERROR",
        children: [/*#__PURE__*/_jsx(ThreadHistoryError, {}), ";"]
      });
    }
    return /*#__PURE__*/_jsx(MessageHistoryContext.Provider, {
      value: {
        AvatarComponent: AsyncUIAvatar
      },
      children: this.renderThreadHistory()
    });
  }
  render() {
    return /*#__PURE__*/_jsx(ThreadHistoryWrapper, {
      children: this.renderThreadHistoryStatusWrapper()
    });
  }
}
UnifiedThreadHistory.displayName = 'UnifiedThreadHistory';
UnifiedThreadHistory.propTypes = propTypes;
export default UnifiedThreadHistory;